const state = {
  history2d: [],
  history3d: [],
  currentExtentIndex2d: null,
  currentExtentIndex3d: null,
  fromHistory: false,
  mode: '2d',
}

const getters = {
  getCurrentExtent (state) {
    if (state.mode === '2d') {
      return state.history2d[state.currentExtentIndex2d]
    }
    return state.history3d[state.currentExtentIndex3d]
  },
  getHasPrevious (state) {
    if (state.mode === '2d') {
      return state.currentExtentIndex2d > 0
    }
    return state.currentExtentIndex3d > 0
  },
  getHasNext (state) {
    if (state.mode === '2d') {
      return state.currentExtentIndex2d < (state.history2d.length - 1)
    }
    return state.currentExtentIndex3d < (state.history3d.length - 1)
  },
  getFromHistory: state => state.fromHistory,
  getMode: state => state.mode,
}

const mutations = {
  add2dExtent (state, extent) {
    if (state.currentExtentIndex2d !== state.history2d.length - 1) {
      state.history2d.slice(state.currentExtentIndex2d + 1)
    }
    state.history2d.push(extent)
    if (state.currentExtentIndex2d === null) {
      state.currentExtentIndex2d = 0
    } else {
      state.currentExtentIndex2d++
    }
  },
  add3dExtent (state, extent) {
    if (state.currentExtentIndex3d !== state.history3d.length - 1) {
      state.history3d.slice(state.currentExtentIndex3d + 1)
    }
    state.history3d.push(extent)
    if (state.currentExtentIndex3d === null) {
      state.currentExtentIndex3d = 0
    } else {
      state.currentExtentIndex3d++
    }
  },
  goToPrevious (state) {
    if (state.mode === '2d') {
      if (state.currentExtentIndex2d > 0) {
        state.fromHistory = true
        state.currentExtentIndex2d--
      }
    } else if (state.currentExtentIndex3d > 0) {
      state.fromHistory = true
      state.currentExtentIndex3d--
    }
  },
  goToNext (state) {
    if (state.mode === '2d') {
      if (state.currentExtentIndex2d < (state.history2d.length - 1)) {
        state.fromHistory = true
        state.currentExtentIndex2d++
      }
    } else if (state.currentExtentIndex3d < (state.history3d.length - 1)) {
      state.fromHistory = true
      state.currentExtentIndex3d++
    }
  },
  setFromHistory (state, fromHistory) {
    state.fromHistory = fromHistory
  },
  resetHistory (state) {
    if (state.mode === '2d') {
      state.history2d = []
      state.mode = '3d'
      state.currentExtentIndex2d = null
    } else {
      state.history3d = []
      state.mode = '2d'
      state.currentExtentIndex3d = null
    }
    state.currentExtentIndex = null
  },
  setMode (state, mode) {
    state.mode = mode
  },
  filterHistory (state) {
    if (state.history2d.length > 1) {
      const length = state.history2d.length
      state.history2d.splice(0, length - 1)
      state.currentExtentIndex2d = 0
    }
    if (state.history3d.length === 1) {
      state.history3d = []
      state.currentExtentIndex3d = null
    }
    if (state.history3d.length > 1) {
      const length = state.history3d.length
      state.history3d.splice(0, length - 1)
      state.currentExtentIndex3d = 0
    }
  },
}

const actions = {
  add2dExtent ({ commit }, extent) {
    commit('add2dExtent', extent)
  },
  add3dExtent ({ commit }, extent) {
    commit('add3dExtent', extent)
  },
  goToPrevious ({ commit }) {
    commit('goToPrevious')
  },
  goToNext ({ commit }) {
    commit('goToNext')
  },
  setFromHistory ({ commit }, fromHistory) {
    commit('setFromHistory', fromHistory)
  },
  resetHistory ({ commit }) {
    commit('resetHistory')
  },
  setMode ({ commit }, mode) {
    commit('setMode', mode)
  },
  filterHistory ({ commit }) {
    commit('filterHistory')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
